/**
 * Currency input formatting — ported from LoanLoop (mortgageme-platform
 * frontend/src/utils/formatCurrency.ts) so the SaaS calculator matches the
 * proven behaviour: show comma separators as the user types, strip them before
 * the value reaches the backend.
 */

/** Strip non-numeric chars (except decimal point): "1,200,000" → "1200000" */
export function stripToNumber(value: string): string {
  return value.replace(/[^0-9.]/g, '')
}

/** Format a numeric string with comma separators: "1200000" → "1,200,000" */
export function formatNumberWithCommas(value: string): string {
  const raw = stripToNumber(value)
  if (!raw) return ''
  const parts = raw.split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}
